import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { servicesContent } from '../data/servicesContent';

/**
 * DISCOVER & DEVELOP YOUR STYLE — editorial chapter opening that introduces
 * the first service path. No service number, no card. Establishes that the
 * services below belong to this chapter.
 */
const DiscoverChapter = () => {
  const { language } = useLanguage();
  const c = servicesContent[language];

  return (
    <section id="discover-develop" className="bg-[#faf7ee] pt-20 lg:pt-28 pb-6 lg:pb-8 overflow-hidden" data-testid="discover-chapter">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          className="max-w-5xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-neutral-900" />
            <span className="text-xs tracking-[0.4em] font-bold uppercase text-neutral-900">
              {language === 'hu' ? 'ELSŐ ÚT' : 'FIRST PATH'}
            </span>
          </div>
          <h2
            className="offering-title leading-[0.92] text-neutral-900"
            style={{ fontWeight: 400, letterSpacing: '0.005em', fontSize: 'clamp(2.5rem, 7vw, 5rem)' }}
          >
            {c.discTitleLine1}
            <br />
            {c.discTitleLine2}
          </h2>
          <div className="w-14 h-[3px] bg-[#CCFF00] mt-6 mb-6" />
          <p className="text-base lg:text-xl text-neutral-700 leading-relaxed max-w-3xl">
            {c.discCopy}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default DiscoverChapter;
